module.exports = __webpack_public_path__ + "static/media/eth.7c199546.svg";